import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { EERIE } from 'HubStyleTokens/colors';
import H5 from 'UIComponents/elements/headings/H5';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';

const ScopeHeader = ({
  icon,
  use,
  children
}) => /*#__PURE__*/_jsxs(UIFlex, {
  className: use === 'island' ? 'm-top-4' : "",
  children: [icon && /*#__PURE__*/_jsx(UIIcon, {
    className: "p-right-3",
    name: icon,
    color: EERIE,
    size: "xs"
  }), /*#__PURE__*/_jsx(H5, {
    className: "m-all-0",
    children: children
  })]
});

ScopeHeader.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  use: PropTypes.oneOf(['island'])
};
export default ScopeHeader;